/** Default teks footer — dipakai website & form admin (prefill). */
export const DEFAULT_FOOTER = {
  about:
    'Supplier bubuk minuman premium terlengkap sejak 2013. Dipercaya ribuan pelaku usaha minuman UMKM, franchise, dan agen di seluruh Indonesia.',
  quick_title: 'Quick Links',
  categories_title: 'Kategori Produk',
  contact_title: 'Hubungi Kami',
  copyright: 'PT BelBel Cahaya Sentosa. All rights reserved.',
  facebook: '',
  youtube: '',
};

export function mergeFooter(partial) {
  return { ...DEFAULT_FOOTER, ...(partial && typeof partial === 'object' ? partial : {}) };
}
